import resolveComponent from '../resolveComponent';

/**
 * @example `/${appid}${appImageTextManagePrefix}`
 * @example `/:appId${appImageTextManagePrefix}`
 *  */
export const appImageTextManagePrefix = '/image-text-manage';
export const appImageTextManagePrefixName = '图文管理';
/**
 * @example `/${appid}${appImageTextManage_HotList}`
 * @example `/:appId${appImageTextManage_HotList}`
 *  */
export const appImageTextManage_HotList = `${appImageTextManagePrefix}/hot-list`;
export const appImageTextManage_HotListName = '热文推荐';

const appImageTextManage_offiaccount = `${appImageTextManagePrefix}/offiaccount`;
const appImageTextManage_offiaccountName = '公众号搜索';

/**
 * @example `/${appid}${appImageTextManage_offiaccount_list}`
 * @example `/:appId${appImageTextManage_offiaccount_list}`
 *  */
export const appImageTextManage_offiaccount_list = `${appImageTextManage_offiaccount}/list`;
export const appImageTextManage_offiaccount_listName = '公众号搜索';

/**
 * @example `/${appid}${appImageTextManage_offiaccount_detail}/${公众号ID}`
 * @example `/:appId${appImageTextManage_offiaccount_detail}/:id`
 *  */
 export const appImageTextManage_offiaccount_detail = `${appImageTextManage_offiaccount}/detail`;
 export const appImageTextManage_offiaccount_detailName = '查看详情';

const ImageTextManageRouteConfig = [
  // {
  //   path: `/:appId?${appImageTextManage_HotList}/copy-list/:id`,
  //   label: '数据管理',
  //   exact: true,
  //   component: resolveComponent(() => import('@src/service')),
  //   children: [
  //     {
  //       path: `/:appId?${appImageTextManage_HotList}/copy-list/:id`,
  //       exact: true,
  //       label: '数据管理',
  //       component: resolveComponent(() => import('@src/pages/app/imageTextManage/copyList')),
  //     },
  //   ],
  // },
  {
    path: `/:appId?${appImageTextManagePrefix}`,
    label: appImageTextManagePrefixName,
    exact: false,
    component: resolveComponent(() => import('@src/service')),
    children: [
      {
        path: `/:appId?${appImageTextManage_HotList}`,
        label: appImageTextManage_HotListName,
        exact: false,
        children: [
          {
            path: `/:appId?${appImageTextManage_HotList}/copy-list/:id`,
            exact: true,
            label: '数据管理',
            component: resolveComponent(() => import('@src/pages/app/imageTextManage/copyList')),
          },
          {
            path: `/:appId?${appImageTextManage_HotList}`,
            exact: true,
            label: '热文推荐',
            component: resolveComponent(() => import('@src/pages/app/imageTextManage/hotList')),
          },
         
        ],
      },
      {
        path: `/:appId?`,
        label: appImageTextManage_offiaccountName,
        exact: false,
        children: [
          {
            path: `/:appId?${appImageTextManage_offiaccount_list}`,
            exact: true,
            label: '',
            component: resolveComponent(() => import('@src/pages/app/imageTextManage/offiaccount/list')),
          },
          {
            path: `/:appId?${appImageTextManage_offiaccount_detail}/:id`,
            exact: true,
            label: appImageTextManage_offiaccount_detailName,
            component: resolveComponent(() => import('@src/pages/app/imageTextManage/offiaccount/detail')),
          },
        ],
      },    
    ],
  },

];

export default ImageTextManageRouteConfig;
